import { createSlice } from '@reduxjs/toolkit'
import * as actions from './actions';
import rippleLogo from '../../assets/icons/rippleLogo.png'
import { asyncRequest } from '../services';

const namespace = 'ripple'


export const createRippleWallet = asyncRequest(`${namespace}/createRippleWallet`, '/xrp/v1/wallet/', 'post')
export const verifyRippleWallet = asyncRequest(`${namespace}/verifyRippleWallet`, (objData) => `/xrp/v1/wallet/${objData.id}/`, 'put')
export const getActiveRippleWallet = asyncRequest(`${namespace}/getActiveRippleWallet`, '/xrp/v1/active_wallet/', 'get')
export const getRippleHoldings = asyncRequest(`${namespace}/getRippleHoldings`, '/xrp/v1/holdings/', 'get')
export const getRippleTransactions = asyncRequest(`${namespace}/getRippleTransactions`, '/xrp/v1/transaction/', 'get')
export const createRippleAsset = asyncRequest(`${namespace}/createRippleAsset`, '/xrp/v1/general_asset/', 'post')
export const rippleOptIn = asyncRequest(`${namespace}/rippleOptIn`, '/xrp/v1/optin/', 'post')
export const rippleOptOut = asyncRequest(`${namespace}/rippleOptOut`, '/xrp/v1/optout/', 'post')
export const getCreatedAssets = asyncRequest(`${namespace}/getCreatedAssets`, '/xrp/v1/created_assets/', 'get')
export const getAllRippleWallets = asyncRequest(`${namespace}/getAllRippleWallets`, '/xrp/v1/wallet/', 'get')
export const updateActiveRippleWallet = asyncRequest(`${namespace}/updateActiveRippleWallet`, (objData) => `/xrp/v1/wallet/${objData.id}/`, 'put')
export const removeRippleWallet = asyncRequest(`${namespace}/removeRippleWallet`, (objData) => `/xrp/v1/wallet/${objData.id}/`, 'delete')
export const sendRipple = asyncRequest(`${namespace}/sendRipple`, '/xrp/v1/send/', 'post')
export const createRippleOffer = asyncRequest(`${namespace}/createRippleOffer`, '/xrp/v1/create_offer/', 'post')
export const searchRippleOffers = asyncRequest(`${namespace}/searchRippleOffers`, '/xrp/v1/all_offer/', 'post')
export const createEscrow = asyncRequest(`${namespace}/createEscrow`, '/xrp/v1/schedule_xrp/', 'post') //*not a mistake
export const scheduleEscrow = asyncRequest(`${namespace}/scheduleEscrow`, '/xrp/v1/schedule_xrp/', 'post')
export const finishEscrow = asyncRequest(`${namespace}/finishEscrow`, '/xrp/v1/finish_escrow/', 'post')
export const cancelEscrow = asyncRequest(`${namespace}/cancelEscrow`, '/xrp/v1/cancel_escrow/', 'post')
export const getCreateEscrowList = asyncRequest(`${namespace}/getCreateEscrowList`, '/xrp/v1/create_escrow/', 'get')
export const getFinishEscrowList = asyncRequest(`${namespace}/getFinishEscrowList`, '/xrp/v1/finish_escrow/', 'get')
export const getCancelEscrowList = asyncRequest(`${namespace}/getCancelEscrowList`, '/xrp/v1/cancel_escrow/', 'get')
export const getAccountEscrowList = asyncRequest(`${namespace}/getAccountEscrowList`, '/xrp/v1/account_escrow/', 'get')
export const getAccountCheckList = asyncRequest(`${namespace}/getAccountCheckList`, '/xrp/v1/account_checks/', 'get')
export const cashXrpCheck = asyncRequest(`${namespace}/cashXrpCheck`, '/xrp/v1/cash_xrp_check/', 'post')
export const cashAssetCheck = asyncRequest(`${namespace}/cashAssetCheck`, '/xrp/v1/cash_asset_check/', 'post')
export const cancelCheck = asyncRequest(`${namespace}/cancelCheck`, '/xrp/v1/cancel_check/', 'post')
export const setRippleNet = asyncRequest(`${namespace}/setRippleNet`, '/xrp/v1/set_net/', 'post')
export const getPendingRippleOffers = asyncRequest(`${namespace}/getPendingRippleOffers`, '/xrp/v1/account_offer/', 'get')
export const getRippleFee = asyncRequest(`${namespace}/getRippleFee`, '/xrp/v1/fee/', 'get')


const DEFAULT = { status: null, data: null, error: null }

const rippleSlice = createSlice({
  name: 'ripple',
  initialState: {
    createWallet: DEFAULT,
    id: null,
    address: "",
    seed: "",
    verifyWallet: DEFAULT,
    activeWallet: DEFAULT,
    transactions: DEFAULT,
    holdings: { ...DEFAULT, data: [{ id: 0, name: 'XRPL', unit: 'Xrp', image: rippleLogo }] },
    optIn: DEFAULT,
    optOut: DEFAULT,
    createdAssets: DEFAULT,
    createEscrow: DEFAULT,
    scheduleEscrow: DEFAULT,
    finishEscrow: DEFAULT,
    cancelEscrow: DEFAULT,
    createAsset: DEFAULT,
    allWallets: DEFAULT,
    updateActiveWallet: DEFAULT,
    removeWallet: DEFAULT,
    send: DEFAULT,
    createOffer: DEFAULT,
    offers: DEFAULT,
    createEscrowList: DEFAULT,
    finishEscrowList: DEFAULT,
    cancelEscrowList: DEFAULT,
    accountEscrowList: DEFAULT,
    accountCheckList: DEFAULT,
    cashCheck: DEFAULT,
    cancelCheck: DEFAULT,
    setNet: DEFAULT,
    pendingOffers: DEFAULT,
    fee: DEFAULT,
  },
  reducers: {
    incorrectSeedError(state, { payload }) {
      state.verifyWallet.error = payload.error
    },
    setRippleSeed(state, action) {
      state.seed = action.payload
    },
  },
  extraReducers: { 
    [createRippleWallet.pending]: actions.createRippleWalletPending,
    [createRippleWallet.fulfilled]: actions.createRippleWalletFulfilled,
    [createRippleWallet.rejected]: actions.createRippleWalletRejected,

    [getActiveRippleWallet.pending]: actions.getActiveRippleWalletPending,
    [getActiveRippleWallet.fulfilled]: actions.getActiveRippleWalletFulfilled,
    [getActiveRippleWallet.rejected]: actions.getActiveRippleWalletRejected,

    [getRippleHoldings.pending]: actions.getRippleHoldingsPending,
    [getRippleHoldings.fulfilled]: actions.getRippleHoldingsFulfilled,
    [getRippleHoldings.rejected]: actions.getRippleHoldingsRejected,

    [getRippleTransactions.pending]: actions.getRippleTransactionsPending,
    [getRippleTransactions.fulfilled]: actions.getRippleTransactionsFulfilled,
    [getRippleTransactions.rejected]: actions.getRippleTransactionsRejected,

    [createRippleAsset.pending]: actions.createRippleAssetPending,
    [createRippleAsset.fulfilled]: actions.createRippleAssetFulfilled,
    [createRippleAsset.rejected]: actions.createRippleAssetRejected,

    [createEscrow.pending]: actions.createEscrowPending,
    [createEscrow.fulfilled]: actions.createEscrowFulfilled,
    [createEscrow.rejected]: actions.createEscrowRejected,

    [scheduleEscrow.pending]: actions.scheduleEscrowPending,
    [scheduleEscrow.fulfilled]: actions.scheduleEscrowFulfilled,
    [scheduleEscrow.rejected]: actions.scheduleEscrowRejected,

    [finishEscrow.pending]: actions.finishEscrowPending,
    [finishEscrow.fulfilled]: actions.finishEscrowFulfilled,
    [finishEscrow.rejected]: actions.finishEscrowRejected,

    [cancelEscrow.pending]: actions.cancelEscrowPending,
    [cancelEscrow.fulfilled]: actions.cancelEscrowFulfilled,
    [cancelEscrow.rejected]: actions.cancelEscrowRejected,

    [rippleOptIn.pending]: actions.rippleOptInPending,
    [rippleOptIn.fulfilled]: actions.rippleOptInFulfilled,
    [rippleOptIn.rejected]: actions.rippleOptInRejected,
    
    [rippleOptOut.pending]: actions.rippleOptOutPending,
    [rippleOptOut.fulfilled]: actions.rippleOptOutFulfilled,
    [rippleOptOut.rejected]: actions.rippleOptOutRejected,

    [getCreatedAssets.pending]: actions.getCreatedAssetsPending,
    [getCreatedAssets.fulfilled]: actions.getCreatedAssetsFulfilled,
    [getCreatedAssets.rejected]: actions.getCreatedAssetsRejected,

    [getAllRippleWallets.pending]: actions.getAllRippleWalletsPending,
    [getAllRippleWallets.fulfilled]: actions.getAllRippleWalletsFulfilled,
    [getAllRippleWallets.rejected]: actions.getAllRippleWalletsRejected,

    [updateActiveRippleWallet.pending]: actions.updateActiveRippleWalletPending,
    [updateActiveRippleWallet.fulfilled]: actions.updateActiveRippleWalletFulfilled,
    [updateActiveRippleWallet.rejected]: actions.updateActiveRippleWalletRejected,

    [removeRippleWallet.pending]: actions.removeRippleWalletPending,
    [removeRippleWallet.fulfilled]: actions.removeRippleWalletFulfilled,
    [removeRippleWallet.rejected]: actions.removeRippleWalletRejected,

    [sendRipple.pending]: actions.sendRipplePending,
    [sendRipple.fulfilled]: actions.sendRippleFulfilled,
    [sendRipple.rejected]: actions.sendRippleRejected,

    [createRippleOffer.pending]: actions.createRippleOfferPending,
    [createRippleOffer.fulfilled]: actions.createRippleOfferFulfilled,
    [createRippleOffer.rejected]: actions.createRippleOfferRejected,

    [searchRippleOffers.pending]: actions.searchRippleOffersPending,
    [searchRippleOffers.fulfilled]: actions.searchRippleOffersFulfilled,
    [searchRippleOffers.rejected]: actions.searchRippleOffersRejected,
    
    [getCreateEscrowList.pending]: actions.getCreateEscrowListPending,
    [getCreateEscrowList.fulfilled]: actions.getCreateEscrowListFulfilled,
    [getCreateEscrowList.rejected]: actions.getCreateEscrowListRejected,

    [getFinishEscrowList.pending]: actions.getFinishEscrowListPending,
    [getFinishEscrowList.fulfilled]: actions.getFinishEscrowListFulfilled,
    [getFinishEscrowList.rejected]: actions.getFinishEscrowListRejected,

    [getCancelEscrowList.pending]: actions.getCancelEscrowListPending,
    [getCancelEscrowList.fulfilled]: actions.getCancelEscrowListFulfilled,
    [getCancelEscrowList.rejected]: actions.getCancelEscrowListRejected,

    [getAccountEscrowList.pending]: actions.getAccountEscrowListPending,
    [getAccountEscrowList.fulfilled]: actions.getAccountEscrowListFulfilled,
    [getAccountEscrowList.rejected]: actions.getAccountEscrowListRejected,

    [getAccountCheckList.pending]: actions.getAccountCheckListPending,
    [getAccountCheckList.fulfilled]: actions.getAccountCheckListFulfilled,
    [getAccountCheckList.rejected]: actions.getAccountCheckListRejected,

    [cashXrpCheck.pending]: actions.cashXrpCheckPending,
    [cashXrpCheck.fulfilled]: actions.cashXrpCheckFulfilled,
    [cashXrpCheck.rejected]: actions.cashXrpCheckRejected,

    [cashAssetCheck.pending]: actions.cashAssetCheckPending,
    [cashAssetCheck.fulfilled]: actions.cashAssetCheckFulfilled,
    [cashAssetCheck.rejected]: actions.cashAssetCheckRejected,

    [cancelCheck.pending]: actions.cancelCheckPending,
    [cancelCheck.fulfilled]: actions.cancelCheckFulfilled,
    [cancelCheck.rejected]: actions.cancelCheckRejected,

    [getPendingRippleOffers.pending]: actions.getPendingRippleOffersPending,
    [getPendingRippleOffers.fulfilled]: actions.getPendingRippleOffersFulfilled,
    [getPendingRippleOffers.rejected]: actions.getPendingRippleOffersRejected,

    [setRippleNet.pending]: actions.setRippleNetPending,
    [setRippleNet.fulfilled]: actions.setRippleNetFulfilled,
    [setRippleNet.rejected]: actions.setRippleNetRejected,

    [getRippleFee.pending]: actions.getRippleFeePending,
    [getRippleFee.fulfilled]: actions.getRippleFeeFulfilled,
    [getRippleFee.rejected]: actions.getRippleFeeRejected,
  }
})

export const { incorrectSeedError, setRippleSeed } = rippleSlice.actions

export default rippleSlice.reducer
